export default (kasko) => {
  kasko.addEventListener('form-changed', ({ current, previous }) => {
    if (previous.insured_sum_hr === current.insured_sum_hr) {
      return;
    }

    kasko.dispatchEvent('set-state-input', {
      manual_insured_sum_hr: current.insured_sum_hr,
    });
    kasko.dispatchEvent('set-form-input', {
      manual_insured_sum_hr: current.insured_sum_hr,
    });
  });
};
